import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const linkUnfurlWeb: PluginWebManifest = {
  overviewCards: [
    {
      to: '/org/plugins/link-unfurl',
      label: 'Link Unfurl',
      icon: 'Link2',
      description: 'Rich previews for links that appear in agent output.',
      details:
        'Detects http(s) links in agent messages and stacks a compact preview card (title, description, image) under the message, one per link, once it scrolls into view. Known providers (YouTube, X) use oEmbed; everything else falls back to OpenGraph scraping. All fetches go through an SSRF-guarded backend.',
      features: [
        'Preview cards stacked under the message, never mid-sentence',
        'Lazy: only fetches once the message scrolls into view',
        'oEmbed for YouTube and X, OpenGraph fallback',
        'SSRF-hardened server fetch with in-memory caching',
      ],
      group: 'plugins',
    },
  ],
  // URL content scanner: every http(s) link in agent markdown gets a lazy
  // preview card stacked under the message. `trailing` placement leaves the
  // link itself alone — it keeps the surface's own anchor styling — and the
  // card renders after the prose, once per unique URL, in the order the links
  // appear.
  contentScanners: [
    {
      id: 'link-unfurl:url',
      target: 'url',
      placement: 'trailing',
      pattern: '^https?:\\/\\/',
      flags: 'i',
      componentPath: '@reflex/plugin-link-unfurl/web/components/UnfurlCard',
      // High order so any future, more-specific url scanner wins ahead of this
      // catch-all.
      order: 100,
    },
  ],
};
